/* =====================================================================
   SLOTIVO.CZ — Landingpage-Logik
   - Echte Slot-Bilder (selbst gehostet in games/, wie bei Freshbet).
   - Klick auf Spiel -> Bonus-Popup mit allen Casinos zur Auswahl.
   - Animierter Flammen-Hintergrund (Glut-Partikel per JS).
   - Mobile-Navigation + Smooth-Scroll.
   Bild-Basis überschreibbar via window.SLOTIVO_ASSET_BASE (für Shopify).
   ===================================================================== */
(function () {
  "use strict";

  // Assets liegen auf der Shopify-CDN (absolute URLs -> laden überall, egal wo die Seite gehostet ist)
  const ASSET = "https://cdn.shopify.com/s/files/1/1011/1074/3414/files/";
  const LOGO = "https://cdn.shopify.com/s/files/1/1011/1074/3414/files/";

  /* ---- Casino-Deals (7 Stars · CZ) — Logos self-hosted in logos/ ---- */
  const CASINOS = [
    { key: "betscore", name: "Betscore", initials: "BS", rating: 4.9, top: true, logo: "betscore.webp?v=1786737270",
      bonus: "350% až do 425 000 Kč + 200 FS + Fortune Wheel",
      link: "https://bsr.lynmonkel.com/?mid=387473_2235998",
      feats: ["Uvítací balíček 350 %", "200 free spinů", "1× Fortune Wheel"] },
    { key: "spinit", name: "Spinit", initials: "SP", rating: 4.7, logo: "spinit.svg?v=1786737269",
      bonus: "100% až do 12 500 Kč + 200 FS",
      link: "https://swp.lynmonkel.com/?mid=387473_2236029",
      feats: ["100% bonus na vklad", "200 free spinů", "Rychlé výplaty"] },
    { key: "casinia", name: "Casinia", initials: "CA", rating: 4.7, logo: "casinia.svg?v=1786737269",
      bonus: "100% až do 12 500 Kč + 200 FS",
      link: "https://csn.lynmonkel.com/?mid=387473_2236030",
      feats: ["100% bonus na vklad", "200 free spinů", "Tisíce her"] },
  ];
  // Logo-Bild mit Fallback auf Initialen-Badge (falls Bild fehlt)
  const logoHtml = (c, cls) => c.logo
    ? `<img class="${cls}-img" src="${LOGO}${esc(c.logo)}" alt="${esc(c.name)}" loading="lazy" onerror="this.style.display='none';this.nextElementSibling.style.display='grid'"><span class="${cls}" style="display:none">${esc(c.initials)}</span>`
    : `<span class="${cls}">${esc(c.initials)}</span>`;

  /* ---- Beliebte Spiele — echte Slot-Bilder (Pragmatic Play, selbst gehostet) ---- */
  const GAMES = [
    { name: "Fire Stampede Ultimate", prov: "Pragmatic Play", img: "fire-stampede.png?v=1786737271",      badge: "HOT", emoji: "🔥", c1: "#b3331f", c2: "#40100a" },
    { name: "Big Bass Blast",         prov: "Pragmatic Play", img: "big-bass-blast.png?v=1786737271",      badge: "HOT", emoji: "🎣", c1: "#1b6ca8", c2: "#0a2a43" },
    { name: "Sweet Bonanza 2500",     prov: "Pragmatic Play", img: "sweet-bonanza-2500.png?v=1786737271",  badge: "",    emoji: "🍭", c1: "#ff5fa2", c2: "#7a1147" },
    { name: "The Dog House 1000",      prov: "Pragmatic Play", img: "dog-house-mw1000.png?v=1786737271",    badge: "",    emoji: "🐶", c1: "#2f9e6f", c2: "#0c3a27" },
    { name: "Hell Butcher",           prov: "Pragmatic Play", img: "hell-butcher.png?v=1786737271",        badge: "HOT", emoji: "😈", c1: "#a01c1c", c2: "#2e0808" },
    { name: "Fury of Anubis",         prov: "Pragmatic Play", img: "fury-anubis.png?v=1786737271",         badge: "",    emoji: "🐺", c1: "#c98a27", c2: "#3a2708" },
    { name: "Big Bass Football",      prov: "Pragmatic Play", img: "big-bass-football.png?v=1786737271",   badge: "",    emoji: "⚽", c1: "#1f7a3f", c2: "#0c2e18" },
    { name: "Candy Rush",             prov: "Pragmatic Play", img: "candy-rush.png?v=1786737271",          badge: "NEW", emoji: "🍬", c1: "#ff7ab0", c2: "#5a1035" },
    { name: "Luxor of Cleopatra",     prov: "Pragmatic Play", img: "luxor-cleopatra.png?v=1786737271",     badge: "",    emoji: "🏺", c1: "#c9a227", c2: "#4a3808" },
    { name: "Dragon Pots Megaways",   prov: "Pragmatic Play", img: "dragon-pots-mw.png?v=1786737271",      badge: "NEW", emoji: "🐉", c1: "#b3331f", c2: "#40100a" },
    { name: "777 Wheel Blitz",        prov: "Pragmatic Play", img: "wheel-blitz-777.png?v=1786737271",     badge: "",    emoji: "🎰", c1: "#c1071e", c2: "#3a060a" },
    { name: "Wild Skullz",            prov: "Pragmatic Play", img: "wild-skullz.png?v=1786737271",         badge: "HOT", emoji: "💀", c1: "#7b4bd6", c2: "#2a1553" },
  ];

  const esc = (v) => String(v == null ? "" : v).replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m]));

  function renderCasinos() {
    const wrap = document.getElementById("slCasinos");
    if (!wrap) return;
    wrap.innerHTML = CASINOS.map((c) => `
      <article class="sl-casino ${c.top ? "top" : ""}">
        ${c.top ? `<div class="sl-casino-flag">★ NEJLEPŠÍ</div>` : ""}
        <div class="sl-casino-brand">${logoHtml(c, "sl-casino-logo")}</div>
        <h3 class="sl-casino-name">${esc(c.name)}</h3>
        <div class="sl-casino-rating">★★★★★ <small>${c.rating.toFixed(1)}/5</small></div>
        <div class="sl-casino-bonus"><small>Uvítací bonus</small><strong>${esc(c.bonus)}</strong></div>
        <ul class="sl-casino-feats">${c.feats.map((f) => `<li>${esc(f)}</li>`).join("")}</ul>
        <a class="sl-btn sl-btn-fire sl-btn-block" href="${esc(c.link)}" target="_blank" rel="noopener sponsored">Hrát nyní →</a>
      </article>`).join("");
  }

  function renderGames() {
    const wrap = document.getElementById("slGames");
    if (!wrap) return;
    wrap.innerHTML = GAMES.map((g, i) => `
      <div class="sl-game" data-game="${i}" role="button" tabindex="0" aria-label="${esc(g.name)}">
        <div class="sl-game-art" style="background:linear-gradient(160deg,${g.c1},${g.c2})"></div>
        <div class="sl-game-emoji">${g.emoji}</div>
        <img class="sl-game-img" src="${ASSET}${esc(g.img)}" alt="${esc(g.name)}" loading="lazy" onerror="this.remove()">
        ${g.badge ? `<div class="sl-game-badge">${esc(g.badge)}</div>` : ""}
        <div class="sl-game-play"><span>▶</span></div>
        <div class="sl-game-info"><strong>${esc(g.name)}</strong><span>${esc(g.prov)}</span></div>
      </div>`).join("");
  }

  function openBonusModal(gameIdx) {
    const g = GAMES[gameIdx]; if (!g) return;
    const modal = document.getElementById("slModal");
    document.getElementById("slModalGame").textContent = g.emoji;
    document.getElementById("slModalTitle").textContent = "Hrát " + g.name;
    document.getElementById("slModalSub").textContent = "Vyberte casino a získejte uvítací bonus:";
    document.getElementById("slModalBody").innerHTML = CASINOS.map((c) => `
      <a class="sl-offer" href="${esc(c.link)}" target="_blank" rel="noopener sponsored">
        <div class="sl-offer-logo">${logoHtml(c, "sl-offer-badge")}</div>
        <div class="sl-offer-info"><strong>${esc(c.name)} ${c.top ? "★" : ""}</strong><span>${esc(c.bonus)}</span></div>
        <span class="sl-btn sl-btn-fire sl-btn-sm">Hrát →</span>
      </a>`).join("");
    modal.classList.add("open");
    document.body.style.overflow = "hidden";
  }
  function closeModal() {
    const modal = document.getElementById("slModal");
    if (modal) modal.classList.remove("open");
    document.body.style.overflow = "";
  }

  /* ---- Animierter Flammen-Hintergrund: Glut-Partikel erzeugen ---- */
  function spawnEmbers() {
    const layer = document.getElementById("slEmbers");
    if (!layer) return;
    const N = window.innerWidth < 700 ? 16 : 30;
    let html = "";
    for (let i = 0; i < N; i++) {
      const left = Math.round(Math.random() * 100);
      const size = 2 + Math.round(Math.random() * 5);
      const dur = 6 + Math.round(Math.random() * 10);
      const delay = -Math.round(Math.random() * 16);
      const drift = (Math.random() * 60 - 30).toFixed(0);
      html += `<span class="sl-ember" style="left:${left}%;width:${size}px;height:${size}px;--dur:${dur}s;--delay:${delay}s;--drift:${drift}px"></span>`;
    }
    layer.innerHTML = html;
  }

  function bind() {
    renderCasinos();
    renderGames();
    spawnEmbers();

    document.addEventListener("click", (e) => {
      const game = e.target.closest("[data-game]");
      if (game) { openBonusModal(parseInt(game.getAttribute("data-game"), 10)); return; }
      if (e.target.closest("[data-sl-close]")) { closeModal(); return; }
      const modal = document.getElementById("slModal");
      if (modal && e.target === modal) closeModal();
      if (e.target.closest("#slBurger")) { document.getElementById("slNav")?.classList.toggle("open"); return; }
      if (e.target.closest(".sl-nav a")) document.getElementById("slNav")?.classList.remove("open");
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeModal();
      if ((e.key === "Enter" || e.key === " ") && document.activeElement?.hasAttribute?.("data-game")) {
        e.preventDefault(); openBonusModal(parseInt(document.activeElement.getAttribute("data-game"), 10));
      }
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bind);
  else bind();
})();


/* ===== Support-Chat-Widget (integriert – war chat-widget.js) ===== */
/* =====================================================================
   AMK / SLOTIVO — Support-Chat-Widget ("Jetzt chatten")
   Self-contained: injiziert Button (unten rechts) + Chatfenster + Styles.
   Spieler schickt Name/E-Mail/Anliegen -> Edge Function `support` ->
   landet in der Zentrale (nach Land). Antworten erscheinen live (Polling).
   Konfig VOR dem Script:  window.AMK_CHAT_COUNTRY = "CZ" | "DE";
   Optional: window.AMK_CHAT = { country, accent, sbUrl, anonKey }.
   ===================================================================== */
(function () {
  "use strict";
  if (window.__amkChatLoaded) return;
  if (document.getElementById("amkzApp") || /\/zentrale/i.test(location.pathname)) return;
  window.__amkChatLoaded = true;

  var CFG = window.AMK_CHAT || {};
  var COUNTRY = (CFG.country || window.AMK_CHAT_COUNTRY || "CZ").toUpperCase();
  var ACCENT = CFG.accent || "#e01e1e";
  var SB_URL = CFG.sbUrl || "https://cbwxgikndyyzdslmfpmo.supabase.co";
  var ANON = CFG.anonKey || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNid3hnaWtuZHl5emRzbG1mcG1vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc4MzYzNTcsImV4cCI6MjA5MzQxMjM1N30.zvKKQ7sN6hhMRmwaJVYmjI0cgZDktyXnTb7iYWL4ZPI";

  var T = COUNTRY === "DE" ? {
    launch: "Jetzt chatten", title: "Support", sub: "Wir sind für dich da",
    name: "Name", email: "E-Mail", msg: "Wie können wir helfen?",
    send: "Senden", start: "Chat starten", reply: "Antwort schreiben…",
    thanks: "Danke! Wir haben deine Anfrage erhalten und melden uns hier.", err: "Fehler – bitte später erneut versuchen."
  } : {
    launch: "Napište nám", title: "Podpora", sub: "Jsme tu pro tebe",
    name: "Jméno", email: "E-mail", msg: "S čím ti můžeme pomoci?",
    send: "Odeslat", start: "Zahájit chat", reply: "Napište zprávu…",
    thanks: "Děkujeme! Tvou zprávu jsme přijali, brzy se ozveme.", err: "Chyba – zkuste to prosím později."
  };

  var LS_R = "amk_chat_req_" + COUNTRY, LS_T = "amk_chat_token_" + COUNTRY;
  var state = { reqId: null, token: null, open: false, poll: null, lastIso: null, msgIds: {} };

  function api(action, params) {
    return fetch(SB_URL + "/functions/v1/support", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + ANON, apikey: ANON },
      body: JSON.stringify(Object.assign({ action: action }, params || {}))
    }).then(function (r) { return r.json(); });
  }
  function esc(v) { return String(v == null ? "" : v).replace(/[&<>"']/g, function (m) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[m]; }); }

  function injectStyle() {
    if (document.getElementById("amk-chat-style")) return;
    var s = document.createElement("style"); s.id = "amk-chat-style";
    s.textContent = [
      ".amkchat-launch{position:fixed;bottom:24px;right:24px;z-index:99998;display:inline-flex;align-items:center;gap:12px;",
      "background:linear-gradient(135deg," + ACCENT + ",#a3000f);color:#fff;border:0;cursor:pointer;font-family:inherit;font-weight:800;",
      "font-size:1rem;padding:14px 22px;border-radius:16px;box-shadow:0 12px 34px -8px rgba(224,30,30,.7);transition:transform .15s,filter .15s}",
      ".amkchat-launch:hover{transform:translateY(-2px);filter:brightness(1.08)}",
      ".amkchat-launch .amkchat-ic{font-size:1.3rem;line-height:1}",
      ".amkchat-launch.hide{display:none}",
      ".amkchat-panel{position:fixed;bottom:24px;right:24px;z-index:99999;width:370px;max-width:calc(100vw - 32px);height:560px;max-height:calc(100vh - 48px);",
      "background:#14090b;border:1px solid rgba(255,90,60,.3);border-radius:20px;box-shadow:0 30px 80px -20px rgba(0,0,0,.85);",
      "display:none;flex-direction:column;overflow:hidden;color:#fff2ef;font-family:inherit}",
      ".amkchat-panel.open{display:flex}",
      ".amkchat-head{background:linear-gradient(135deg," + ACCENT + ",#a3000f);padding:16px 18px;display:flex;align-items:center;justify-content:space-between;gap:10px}",
      ".amkchat-head strong{font-size:1.05rem;display:block}.amkchat-head small{opacity:.85;font-size:.8rem}",
      ".amkchat-x{background:rgba(255,255,255,.18);border:0;color:#fff;width:32px;height:32px;border-radius:10px;font-size:1.1rem;cursor:pointer}",
      ".amkchat-body{flex:1;display:flex;flex-direction:column;min-height:0}",
      ".amkchat-form{padding:18px;display:flex;flex-direction:column;gap:11px}",
      ".amkchat-form label{font-size:.8rem;font-weight:700;opacity:.8;display:flex;flex-direction:column;gap:5px}",
      ".amkchat-form input,.amkchat-form textarea{background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.15);color:#fff;border-radius:11px;padding:11px 13px;font:inherit;font-size:.92rem}",
      ".amkchat-form textarea{resize:none;min-height:90px}",
      ".amkchat-send{background:linear-gradient(135deg," + ACCENT + ",#a3000f);border:0;color:#fff;font-weight:800;border-radius:12px;padding:13px;font-size:.98rem;cursor:pointer}",
      ".amkchat-msgs{flex:1;overflow:auto;padding:16px;display:flex;flex-direction:column;gap:9px}",
      ".amkchat-m{max-width:82%;padding:9px 13px;border-radius:14px;font-size:.9rem;line-height:1.45}",
      ".amkchat-m.player{align-self:flex-end;background:linear-gradient(135deg," + ACCENT + ",#a3000f);border-bottom-right-radius:4px}",
      ".amkchat-m.staff{align-self:flex-start;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.12);border-bottom-left-radius:4px}",
      ".amkchat-foot{border-top:1px solid rgba(255,255,255,.1);padding:11px;display:flex;gap:8px}",
      ".amkchat-foot textarea{flex:1;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.15);color:#fff;border-radius:11px;padding:10px 12px;font:inherit;resize:none;height:42px}",
      ".amkchat-foot button{background:linear-gradient(135deg," + ACCENT + ",#a3000f);border:0;color:#fff;font-weight:800;border-radius:11px;padding:0 16px;cursor:pointer}",
      ".amkchat-note{padding:12px 16px;font-size:.82rem;opacity:.7;text-align:center}",
      ".amkchat-img{cursor:pointer;display:grid;place-items:center;width:44px;height:42px;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.15);border-radius:11px;font-size:1.15rem;flex:none}",
      ".amkchat-img:hover{background:rgba(255,255,255,.12)}",
      ".amkchat-m.img{padding:3px !important;background:none !important;border:0 !important}",
      ".amkchat-imgmsg{max-width:210px;max-height:230px;border-radius:12px;display:block;cursor:pointer;object-fit:cover}",
      "@media(max-width:480px){.amkchat-panel{bottom:0;right:0;width:100vw;height:100vh;max-height:100vh;border-radius:0}.amkchat-launch{bottom:16px;right:16px}}"
    ].join("");
    document.head.appendChild(s);
  }

  var launch, panel, bodyEl;
  function build() {
    injectStyle();
    launch = document.createElement("button");
    launch.className = "amkchat-launch";
    launch.innerHTML = '<span>' + esc(T.launch) + '</span><span class="amkchat-ic">💬</span>';
    launch.addEventListener("click", openPanel);
    document.body.appendChild(launch);

    panel = document.createElement("div");
    panel.className = "amkchat-panel";
    panel.innerHTML = '<div class="amkchat-head"><div><strong>' + esc(T.title) + '</strong><small>' + esc(T.sub) + '</small></div><button class="amkchat-x" aria-label="X">×</button></div><div class="amkchat-body" id="amkchatBody"></div>';
    document.body.appendChild(panel);
    panel.querySelector(".amkchat-x").addEventListener("click", closePanel);
    bodyEl = panel.querySelector("#amkchatBody");
  }

  function openPanel() { state.open = true; launch.classList.add("hide"); panel.classList.add("open"); if (state.reqId && state.token) renderChat(); else renderForm(); }
  function closePanel() { state.open = false; panel.classList.remove("open"); launch.classList.remove("hide"); stopPoll(); }

  function renderForm() {
    bodyEl.innerHTML =
      '<form class="amkchat-form" id="amkchatForm">' +
      '<label>' + esc(T.name) + '<input id="acName" type="text" autocomplete="name"></label>' +
      '<label>' + esc(T.email) + '<input id="acEmail" type="email" autocomplete="email"></label>' +
      '<label>' + esc(T.msg) + '<textarea id="acMsg" required></textarea></label>' +
      '<button class="amkchat-send" type="submit">' + esc(T.start) + '</button>' +
      '</form>';
    bodyEl.querySelector("#amkchatForm").addEventListener("submit", function (e) {
      e.preventDefault();
      var msg = bodyEl.querySelector("#acMsg").value.trim(); if (!msg) return;
      var btn = bodyEl.querySelector(".amkchat-send"); btn.disabled = true; btn.textContent = "…";
      api("create", { country: COUNTRY, name: bodyEl.querySelector("#acName").value.trim(), email: bodyEl.querySelector("#acEmail").value.trim(), message: msg })
        .then(function (r) {
          if (r && r.ok) {
            state.reqId = r.request_id; state.token = r.client_token;
            /* Session bewusst NICHT speichern -> nach Refresh erscheint wieder das Formular; Zuordnung im Backend via E-Mail */
            renderChat();
          } else { btn.disabled = false; btn.textContent = T.start; alert(T.err); }
        }).catch(function () { btn.disabled = false; btn.textContent = T.start; alert(T.err); });
    });
  }

  function renderChat() {
    bodyEl.innerHTML =
      '<div class="amkchat-msgs" id="amkchatMsgs"></div>' +
      '<div class="amkchat-foot"><label class="amkchat-img" title="Bild senden">📷<input type="file" accept="image/*" id="amkchatImg" hidden></label><textarea id="amkchatInput" placeholder="' + esc(T.reply) + '"></textarea><button id="amkchatSend">' + esc(T.send) + '</button></div>';
    state.msgIds = {}; state.lastIso = null;
    var input = bodyEl.querySelector("#amkchatInput");
    bodyEl.querySelector("#amkchatSend").addEventListener("click", sendMsg);
    input.addEventListener("keydown", function (e) { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendMsg(); } });
    bodyEl.querySelector("#amkchatImg").addEventListener("change", function (e) { if (e.target.files && e.target.files[0]) sendImage(e.target.files[0]); e.target.value = ""; });
    pollOnce(); startPoll();
  }

  function uploadImage(file) {
    var path = "sup/" + (state.reqId || "anon") + "/" + Date.now() + "_" + String(file.name || "bild").replace(/[^\w.\-]/g, "_");
    return fetch(SB_URL + "/storage/v1/object/amk-support/" + path, {
      method: "POST",
      headers: { "Authorization": "Bearer " + ANON, "apikey": ANON, "Content-Type": file.type || "application/octet-stream", "x-upsert": "true" },
      body: file
    }).then(function (r) { if (!r.ok) throw new Error("upload"); return SB_URL + "/storage/v1/object/public/amk-support/" + path; });
  }
  function sendImage(file) {
    if (!file || !state.reqId) return;
    uploadImage(file).then(function (url) {
      var body = "[img]" + url;
      api("send", { request_id: state.reqId, client_token: state.token, message: body }).then(function () { pollOnce(); }).catch(function () {});
      addMsg({ id: "tmpimg" + Date.now(), sender: "player", body: body, created_at: new Date().toISOString() });
    }).catch(function () { alert(T.err); });
  }

  function addMsg(m) {
    if (state.msgIds[m.id]) return; state.msgIds[m.id] = 1;
    var box = bodyEl.querySelector("#amkchatMsgs"); if (!box) return;
    var d = document.createElement("div");
    d.className = "amkchat-m " + (m.sender === "staff" ? "staff" : "player");
    var img = /^\[img\](https?:\/\/\S+)/i.exec(m.body || "");
    if (img) { d.classList.add("img"); d.innerHTML = '<img class="amkchat-imgmsg" src="' + esc(img[1]) + '" alt="Bild">'; d.querySelector("img").addEventListener("click", function () { window.open(img[1], "_blank", "noopener"); }); }
    else d.textContent = m.body;
    box.appendChild(d); box.scrollTop = box.scrollHeight;
    if (m.created_at) state.lastIso = m.created_at;
  }

  function sendMsg() {
    var input = bodyEl.querySelector("#amkchatInput"); var txt = input ? input.value.trim() : ""; if (!txt) return;
    input.value = "";
    api("send", { request_id: state.reqId, client_token: state.token, message: txt })
      .then(function () { pollOnce(); }).catch(function () {});
    // optimistisch anzeigen
    addMsg({ id: "tmp" + Date.now(), sender: "player", body: txt, created_at: new Date().toISOString() });
  }

  function pollOnce() {
    if (!state.reqId || !state.token) return;
    api("poll", { request_id: state.reqId, client_token: state.token, since: state.lastIso })
      .then(function (r) { if (r && r.ok && r.messages) r.messages.forEach(addMsg); })
      .catch(function () {});
  }
  function startPoll() { stopPoll(); state.poll = setInterval(function () { if (state.open) pollOnce(); }, 4000); }
  function stopPoll() { if (state.poll) { clearInterval(state.poll); state.poll = null; } }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", build);
  else build();
})();

/* =====================================================================
   TÝDENNÍ SOUTĚŽ — E-Mail-Anmeldung (10 × 50 € / Woche)
   Schreibt in Supabase via Edge Function `cz-raffle` (action: signup).
   Die Tabelle amk_cz_raffle ist RLS-gesperrt — Insert läuft serverseitig
   (Service-Role) in der Function, damit KEIN Besucher die Mails auslesen kann.
   In der Zentrale erscheinen die Anmeldungen unter Giveaway → 🇨🇿 Verlosung.
   ===================================================================== */
(function () {
  "use strict";
  var CFG = window.AMK_CHAT || {};
  var SB_URL = CFG.sbUrl || "https://cbwxgikndyyzdslmfpmo.supabase.co";
  var ANON = CFG.anonKey || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNid3hnaWtuZHl5emRzbG1mcG1vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc4MzYzNTcsImV4cCI6MjA5MzQxMjM1N30.zvKKQ7sN6hhMRmwaJVYmjI0cgZDktyXnTb7iYWL4ZPI";
  var RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function init() {
    var form = document.getElementById("slRaffleForm"); if (!form) return;
    var email = document.getElementById("slRaffleEmail");
    var btn = document.getElementById("slRaffleBtn");
    var msg = document.getElementById("slRaffleMsg");
    var box = document.getElementById("slRaffle");

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var val = (email.value || "").trim();
      msg.className = "sl-raffle-msg";
      if (!RE.test(val)) {
        email.classList.add("err"); email.focus();
        msg.textContent = "Zadej prosím platný e-mail."; msg.classList.add("bad");
        return;
      }
      email.classList.remove("err");
      btn.disabled = true; var old = btn.textContent; btn.textContent = "Odesílám…";

      fetch(SB_URL + "/functions/v1/cz-raffle", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + ANON, apikey: ANON },
        body: JSON.stringify({ action: "signup", email: val, source: "frontpage", locale: "cs" })
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (r) {
          if (r && r.ok) {
            if (box) box.classList.add("done");
            msg.textContent = r.already
              ? "Už jsi v seznamu — hodně štěstí! 🍀"
              : "Hotovo! Jsi ve slosování. 🎉 Výherce kontaktujeme e-mailem.";
            msg.classList.add("ok");
          } else {
            btn.disabled = false; btn.textContent = old;
            msg.textContent = "Něco se pokazilo. Zkus to prosím znovu.";
            msg.classList.add("bad");
          }
        })
        .catch(function () {
          btn.disabled = false; btn.textContent = old;
          msg.textContent = "Bez připojení. Zkus to prosím znovu.";
          msg.classList.add("bad");
        });
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();